module.exports = __webpack_public_path__ + "img/bold-forward.a0e402d6.svg";